import PropTypes from 'prop-types';
import homeServiceAttributeShape from './homeServiceAtrributeShape';

const homeServiceShape = {
  id: PropTypes.number.isRequired,
  attributes: PropTypes.shape(homeServiceAttributeShape).isRequired,
};

export default homeServiceShape;
